<template>
    <div class="selectionCard">
        <h2 class="uppercase" v-if="selected"> {{ selected }} </h2>
        <ul>
            <li>
                <input v-model="verb.infinitive" type="text" :disabled="disabled" :class="{active: focus === 0}">
                <span>BASE</span>

                <button class="speech-button" v-if="speech && canSpeech" @click="speechText(verb.infinitive)"><img src="../assets/images/speaker.png"/></button>
            </li>
            <li>
                <input v-model="verb.simplePast" type="text" :disabled="disabled" :class="{active: focus === 1}">
                <span> SIMPLE PAST</span>

                <button class="speech-button" v-if="speech && canSpeech" @click="speechText(verb.simplePast)"><img src="../assets/images/speaker.png"/></button>

            </li>
            <li>
                <input v-model="verb.pastParticiple" type="text" :disabled="disabled" :class="{active: focus === 2}">
                <span> PAST PARTICIPLE</span>

                <button class="speech-button" v-if="speech && canSpeech" @click="speechText(verb.pastParticiple)"><img src="../assets/images/speaker.png"/></button>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: ["selected", "verb", "focus", "disabled", "speech"],
        data() {
          return {
              canSpeech: true
          }
        },
        created() {
            if ('speechSynthesis' in window){
                this.canSpeech = true;
            } else {
                this.canSpeech = false;
            }
        },
        methods: {
            speechText(text){
                let msg = new SpeechSynthesisUtterance();
                // Set the text.
                msg.text = text;
                // Queue this utterance.
                window.speechSynthesis.speak(msg);
            }
        }
    }
</script>